import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { IApplicationState } from '../../combiners'
import { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { reset } from '../actions'

export const useNotification = () => {
  const { message, severity } = useSelector(
    createSelector(
      (state: IApplicationState) => state.notification,
      ({ message, severity }) => ({ message, severity })
    )
  )

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (message !== undefined) {
      enqueueSnackbar(message, { variant: severity })
      dispatch(reset())
    }
  }, [message, severity, enqueueSnackbar, dispatch])
}
